export enum AwardType {
  PRODUCT_AWARD = 'PRODUCT_AWARD',
  COMPANY_AWARD = 'COMPANY_AWARD',
  PURCHASING_REQUEST = 'PURCHASING_REQUEST',
}
